var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgButtonArrowIcon = function SvgButtonArrowIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "665ed674213503b02c06c889_w-btn-arrow.svg"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M3.75 12.0254L11.875 3.90039M11.875 3.90039V11.7004M11.875 3.90039H4.075",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
};
export default SvgButtonArrowIcon;